import { cn } from "@/lib/utils";

/**
 * Page header used at the top of the main views: a small uppercase eyebrow label, a serif
 * display title (the page's h1 — its text is the accessible name), an optional description
 * and an actions slot.
 */
export function PageHeader({
  eyebrow,
  title,
  description,
  actions,
  icon,
  className,
}: {
  eyebrow?: React.ReactNode;
  title: React.ReactNode;
  description?: React.ReactNode;
  actions?: React.ReactNode;
  icon?: React.ReactNode;
  className?: string;
}) {
  return (
    <header className={cn("flex flex-col gap-3 pb-1 sm:flex-row sm:items-end", className)}>
      <div className="min-w-0 flex-1">
        {eyebrow && <p className="text-[0.68rem] font-semibold uppercase tracking-[0.14em] text-muted-foreground">{eyebrow}</p>}
        <h1 className="font-display mt-1 flex items-center gap-2 text-[1.7rem] leading-tight font-semibold text-foreground sm:text-[2rem]">
          {icon && (
            <span className="text-muted-foreground [&>svg]:size-6" aria-hidden>
              {icon}
            </span>
          )}
          {title}
        </h1>
        {description && <div className="mt-1.5 max-w-3xl text-sm leading-relaxed text-muted-foreground">{description}</div>}
      </div>
      {actions && <div className="flex flex-wrap items-center gap-1.5 sm:justify-end">{actions}</div>}
    </header>
  );
}
